<template>
  <div class="testimonial-slider">
    <div class="testimonial-slider__header">
      <h2 class="testimonial-slider__title">{{ title }}</h2>
    </div>
    <div class="swiper__container">
      <swiper
        class="testimonial-slider__slider"
        :modules="modules"
        :slides-per-view="1"
        :space-between="gutter"
        :navigation="navigation"
        :pagination="{ clickable: true }"
        :slidesOffsetAfter="paddingRight"
        :slidesOffsetBefore="paddingLeft"
        @swiper="onSwiper"
        :resizeObserver="true"
        @slideChange="onSlideChange"
        :breakpoints="breakpoints"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <div class="testimonial-slider__slide">
            <div class="testimonial-slider__slide-content">{{ slide.content }}</div>
            <div class="testimonial-slider__slide-tagline">{{ slide.name_job_title }}</div>
          </div>
        </swiper-slide>
      </swiper>
      <button class="testimonial-slider__swiper-prev swiper__button swiper__button--prev" type="button"><span>Prev</span></button>
      <button class="testimonial-slider__swiper-next swiper__button swiper__button--next" type="button"><span>Next</span></button>
    </div>
  </div>
</template>
<script>
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/bundle";

export default {
  props: ["title", "slides"],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      gutter: 16,
      paddingLeft: 0,
      paddingRight: 0,
    };
  },
  mounted() {
    let self = this;
    self.setSidePadding();
    window.addEventListener("resize", function () {
      self.setSidePadding();
    });
  },
  methods: {
    setSidePadding: function () {
      // spacing
      if (window.innerWidth >= 960) {
        this.paddingLeft = 0;
        this.paddingRight = 0;
      } else {
        this.paddingLeft = 16;
        this.paddingRight = 16;
      }
    },
  },
  setup() {
    const onSwiper = (swiper) => {
    };
    const onSlideChange = () => {
    };
    return {
      onSwiper,
      onSlideChange,
      navigation: {
        nextEl: ".testimonial-slider__swiper-next",
        prevEl: ".testimonial-slider__swiper-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 1.4,
        },
        960: {
          slidesPerView: 2,
        },
      },
      modules: [Navigation, Pagination],
    };
  },
};
</script>
